import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVolver = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "volver",
		transform: "translate(-277.509 3467.726)",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Grupo_9377",
			"data-name": "Grupo 9377",
			transform: "translate(-962.491 -3578.726)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Fill_46",
				"data-name": "Fill 46",
				d: "M19.25,22H2.75A2.753,2.753,0,0,1,0,19.25V2.75A2.753,2.753,0,0,1,2.75,0h16.5A2.753,2.753,0,0,1,22,2.75v16.5A2.753,2.753,0,0,1,19.25,22ZM2.75,1.375A1.376,1.376,0,0,0,1.375,2.75v16.5A1.376,1.376,0,0,0,2.75,20.625h16.5a1.376,1.376,0,0,0,1.375-1.375V2.75A1.376,1.376,0,0,0,19.25,1.375ZM10.195,15.7a.683.683,0,0,1-.486-.2L5.82,11.6a.673.673,0,0,1-.179-.6.675.675,0,0,1,.179-.6L9.708,6.507a.687.687,0,1,1,.972.972L7.847,10.313h7.278a.687.687,0,1,1,0,1.375H7.847L10.68,14.52a.689.689,0,0,1-.486,1.177Z",
				transform: "translate(1240 111)",
				fill: "#3b3f35"
			})
		})
	})]
});
const ForwardRef = forwardRef(SvgVolver);
export { ForwardRef as ReactComponent };
